/**
 * 环境变量
 *
 * @returns
 */
function env() {
	return process.env.NODE_ENV || 'development';
}

function isProd() {
	const NODE_ENV = env();
	return NODE_ENV === 'production';
}

function noop() { }

function noopPromise() {
	return new Promise((resolve) => resolve());
}

function questionParse(...questions) {
	return questions.map(question => {
		let content = question.content;
		let section = question.section;
		if (typeof content === 'string') {
			try {
				content = JSON.parse(content);
				question.content = content;
			} catch (ignored) {
			}
		}

		if (typeof section === 'string') {
			try {
				section = JSON.parse(section);
				question.section = section;
			} catch (ignored) {
			}
		}

		return question;
	});
}

function isNull(val) {
	return toString.call(val) === '[object Null]';
}

function isUndefined(val) {
	return toString.call(val) === '[object Undefined]';
}

/**
 * Checks if value is null or undefined.
 *
 * @param {*} val
 * @returns
 */
function isNil(val) {
	return isNull(val) || isUndefined(val);
}

function flat(tree, nodes = [], field = 'children') {
	if (Array.isArray(tree)) {
		tree.forEach(t => flat(t, nodes, field));
	} else {
		nodes.push(tree);
		if (Array.isArray(tree[field]) && tree[field].length > 0) {
			flat(tree[field], nodes, field);
		}
	}
}

export {
	env,
	isProd,
	noop,
	noopPromise,
	questionParse,
	isNull,
	isUndefined,
	isNil,
	flat
};

